const SELECTOR = '[data-product-card-slider]'

function getActiveGap(section) {
  return parseFloat(getComputedStyle(section).getPropertyValue('--product-card-slider-gap')) || 0
}

function dismissNavigation(section) {
  if (!section || section.dataset.productCardSliderNavigationDismissed === 'true') return

  section.dataset.productCardSliderNavigationDismissed = 'true'
  section.classList.add('product-card-slider--navigation-dismissed')
}

function syncSpaceBetween(swiper) {
  const section = swiper.el.closest(SELECTOR)

  if (!section) return

  const spaceBetween = getActiveGap(section)

  if (swiper.params.spaceBetween === spaceBetween) return

  swiper.params.spaceBetween = spaceBetween
  swiper.originalParams.spaceBetween = spaceBetween
}

function createConfig(section) {
  return {
    slidesPerView: 'auto',
    spaceBetween: getActiveGap(section),
    speed: 500,
    threshold: 6,
    grabCursor: true,
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      sensitivity: 1
    },
    watchOverflow: true,
    observer: true,
    observeParents: true,
    navigation: {
      prevEl: section.querySelector('[data-product-card-slider-previous]'),
      nextEl: section.querySelector('[data-product-card-slider-next]')
    },
    on: {
      init(swiper) {
        syncSpaceBetween(swiper)
      },
      sliderFirstMove(swiper) {
        dismissNavigation(section)
      },
      breakpoint(swiper) {
        syncSpaceBetween(swiper)
      },
      resize(swiper) {
        syncSpaceBetween(swiper)
      }
    }
  }
}

function initSection(section) {
  if (section.dataset.productCardSliderInitialized === 'true') return

  const viewport = section.querySelector('[data-product-card-slider-viewport]')

  if (!viewport || typeof window.Swiper !== 'function') return

  const handleWheel = (event) => {
    if (event.deltaX === 0 && event.deltaY === 0) return

    dismissNavigation(section)
  }

  section.dataset.productCardSliderInitialized = 'true'
  section.productCardSliderWheelHandler = handleWheel
  viewport.addEventListener('wheel', handleWheel, { passive: true })
  section.productCardSliderSwiper = new window.Swiper(viewport, createConfig(section))
}

function destroySection(section) {
  const viewport = section.querySelector('[data-product-card-slider-viewport]')

  if (viewport && section.productCardSliderWheelHandler) {
    viewport.removeEventListener('wheel', section.productCardSliderWheelHandler)
  }

  section.productCardSliderWheelHandler = null

  if (!section.productCardSliderSwiper) return

  section.productCardSliderSwiper.destroy(true, true)
  section.productCardSliderSwiper = null
  delete section.dataset.productCardSliderInitialized
}

function init() {
  document.querySelectorAll(SELECTOR).forEach(initSection)
}

function onSectionUnload(event) {
  const section = event.target.matches?.(SELECTOR) ? event.target : event.target.querySelector(SELECTOR)

  if (!section) return

  destroySection(section)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}

document.addEventListener('shopify:section:load', init)
document.addEventListener('shopify:section:unload', onSectionUnload)
